import { Table } from 'react-bootstrap';
import styled from "styled-components";

export const TableWrapper = styled.table`
    margin-bottom: 0px;

    tbody+tbody::before  {
        content: '';
        display: block;
        height: 0px;
        width: 100%;
    }
    
    & > thead > tr > th {
        text-align: center;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr.voucher-pediatric {
        background-color: green;
        color: white;
    }

    & > tbody > tr.voucher-pediatric > td,
    & > tbody > tr.voucher-pediatric > td > a,
    & > tbody > tr.voucher-pediatric > td > button {
        color: white;
    }

    & > tbody > tr.voucher-special-priority {
        background-color: #FF9999;
    }

    & > tbody > tr.voucher-compatible {
        background-color: #FF9999;
    }

    & > tbody > tr.voucher-special {
        background-color: #FFC000;
    }

    & > tbody > tr.voucher-regular {
        background-color: #94DCF8;
    }

    & > tbody > tr.voucher-general {
        background-color: #E49EDD;
    }

    & > tbody > tr > td > span.glyphicon {
        color: #a1a1a1;
    }
`;

export const IPotentialDonorTable = styled(Table)`
    & > thead > tr > th {
        text-align: center;
    }
    
    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }
`;

interface IRowWrapper {
    rowColor: string
}

export const RowWrapper = styled.tr<IRowWrapper>`
    & > td {
        background-color: ${p => p.rowColor};
    }
`;

export const SummaryWrapper = styled.table`
    & > thead > tr > th {
        background-color: #123666;
        color: white;
        font-weight: bold;
    }

    & > thead > tr > th, & > tbody > tr > td {
        text-align: center;
        font-size: 12px;
    }

    & > tbody > tr:nth-of-type(odd) {
        background-color: #dfdfdf;
    }
`;

export const CurrentUnmatchedViableDonorMatchesWrapper = styled.table`
    & > thead > tr > th {
        background-color: #123666;
        color: white;
        font-weight: bold;
    }

    & > thead > tr > th, & > tbody > tr > td {
        text-align: center;
        font-size: 12px;
    }

    & > tbody > tr:nth-of-type(odd) {
        background-color: #dfdfdf;
    }
`;

export const MonthsWaitWrapper = styled.div`
    & > div.row {
        font-size: 12px;
        height: 28px;
    }

    & > div.row > div[class^="col-"] {
        text-align: center;
    }
`;

export const MonthsWaitWrapperScroll = styled.div`
    height: 224px !important;
    overflow-y: scroll;
    border: 1px solid #ddd;

    & > div.row {
        display: flex;
        align-items: center;
        height: 28px;
        font-size: 12px;
    }

    & > div.row:nth-of-type(odd) {
        background-color: #dfdfdf;
    }

    & > div.row > div[class^="col-"] {
        text-align: center;
    }
`;

export const DonorsPerMonthByAboWrapper = styled.table`
    & > thead > tr > th {
        background-color: #123666;
        color: white;
        font-weight: bold;
    }

    & > thead > tr > th, & > tbody > tr > td {
        text-align: center;
        font-size: 12px;
    }

    & > tbody > tr.tr-alt-striped > td {
        background-color: #DDDD88 !important;
    }

    & > tbody > tr:nth-of-type(odd) {
        background-color: #dfdfdf;
    }
`;

export const TriggerRexmTableWrapper = styled.table`
    & > thead > tr > th {
        text-align: center;
        background-color: #123666;
        color: white;
    }

    & > tbody > tr > td {
        text-align: center
    }
`;

export const ButtonWrapper = styled.div`
    div {
        text-align: center;
    }

    //.scenario-button:nth-child(0),
    //.scenario-button:nth-child(3) {
    .scenario-button {
        margin-bottom: 1px;
    }
`;

export const TargetsContentWrapper = styled.div`
    position: relative;
`;

export const GridWrapper = styled.div`
    border: 1px solid #ddd;

    .ag-header-row {
        border-bottom: 1px solid #ddd;
    }

    .ag-header-cell > .ag-react-container {
        width: 100%;
        display: flex;
        justify-content: center;
        font-weight: 550;
    }

    .ag-row > .ag-cell {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .ag-row:hover {
        background-color: #eaf2fa;
    }

    span.glyphicon {
        color: #a1a1a1;
    }

    .hard-to-match-available {
        background-color: #5DFC0A;
    }

    .hard-to-match-not-available {
        background-color: #FFB6C1;
    }
        
    .hard-to-match-in-match {
        background-color: yellow;
    }

    .voucher-special-priority {
        background-color: #FF9999;
    }

    .voucher-compatible {
        background-color: #FF9999;
    }

    .voucher-special {
        background-color: #FFC000;
    }

    .voucher-regular {
        background-color: #94DCF8;
    }

    .voucher-general {
        background-color: #E49EDD;
    }

    .potential-donors {
        padding-top: 3px;
        padding-left: 5px;
        color: #A1A1A1;
    }

    .potential-donors > div > svg {
        vertical-align: top !important;
    }
`;

export const rowColorMap = [
    { majorSortMin: 0, majorSortMax: 10, style: 'voucher-special-priority' },
    { majorSortMin: 10, majorSortMax: 20, style: 'voucher-compatible' },
    { majorSortMin: 20, majorSortMax: 30, style: 'voucher-special' },
    { majorSortMin: 30, majorSortMax: 40, style: 'voucher-regular' },
    { majorSortMin: 40, majorSortMax: 50, style: 'voucher-general' },
];

export const BreakdownWrapper = styled(Table)`
    border-collapse: collapse; /* ensures borders between cells are clean */
    width: 100%;

    & > thead > tr > th {
        background-color: #f0f0f0; /* light grey */
        border: 1px solid #ccc;     /* border around header cells */
        text-align: center;
        vertical-align: middle;
        padding: 3px;
    }

    & > tbody > tr > td {
        border: 1px solid #ccc;     /* border around body cells */
        text-align: center;
        vertical-align: middle;
        padding: 3px;
    }

    & > tbody > tr > td.rowLabel {
        font-weight: bold;
        text-align: left;           /* keep left-aligned row labels */
    }

    /* for the first BreakdownWrapper (4-column table) */
    // &:first-of-type > thead > tr > th:nth-child(1),
    // &:first-of-type > tbody > tr > td:nth-child(1) {
    //     width: 7%;
    // }

    // &:first-of-type > thead > tr > th:nth-child(2),
    // &:first-of-type > tbody > tr > td:nth-child(2) {
    //     width: 40%;
    // }

    // &:first-of-type > thead > tr > th:nth-child(3),
    // &:first-of-type > tbody > tr > td:nth-child(3) {
    //     width: 40%;
    // }

    // &:first-of-type > thead > tr > th:nth-child(4),
    // &:first-of-type > tbody > tr > td:nth-child(4) {
    //     width: 7%;
    // }

    /* for the SECOND BreakdownWrapper (3-column table) */
    &:nth-of-type(2) > thead > tr > th:nth-child(1),
    &:nth-of-type(2) > tbody > tr > td:nth-child(1) {
        width: 20%;  /* increased from 7% */
    }

    &:nth-of-type(2) > thead > tr > th:nth-child(2),
    &:nth-of-type(2) > tbody > tr > td:nth-child(2) {
        width: 40%;
    }
`;
